import { Flex, Typography } from 'antd';
// dynamic import to avoid SSR issues with lotie-react
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import premastLoading from '../../../../public/lottie/premast-loading.json';
const Lottie = dynamic(() => import('lottie-react'), { ssr: false });
const { Text } = Typography;

export default function AuthProtected({ children }) {
   const currentUser = useSWR('/api/user/current');
   const router = useRouter();

   if (currentUser.isLoading) {
      return (
         <Flex vertical align="center" justify="center" gap={32} style={{ width: '100%', height: '100vh' }}>
            <Lottie animationData={premastLoading} style={{ width: 200, height: 200 }} />
            <Text type="secondary">Loading...</Text>
         </Flex>
      );
   }

   if (currentUser.data) {
      return <>{children}</>;
   }

   //  go to login with redirect query parameter to return to the current page after a successful login
   if (!currentUser.data) {
      router.push(`/login?redirect=${window.location.pathname + window.location.search}`);
      return (
         <Flex vertical align="center" justify="center" gap={32} style={{ width: '100%', height: '100vh' }}>
            <Lottie animationData={premastLoading} style={{ width: 200, height: 200 }} />
            <Text type="secondary">Redirecting...</Text>
         </Flex>
      );
   }
}
